import { UserModel } from "./model";

export const dummyUserRow: UserModel = {
  userId: "string",
  userName: "string",
  userType: "SystemAdmin",
  active: true,
  createdBy: "string",
  lastUpdatedBy: "string",
  createdTime: new Date("2025-01-11T19:53:00.057Z"),
  lastUpdatedTime: new Date("2025-01-11T19:53:00.057Z"),
};

export const dummyOrganizationRow = {
  organizationId: 1,
  fullName: "string",
  shortName: "string",
  active: true,
  createdBy: "string",
  lastUpdatedBy: "string",
  createdTime: "2025-01-11T19:53:00.057Z",
  lastUpdatedTime: "2025-01-11T19:53:00.057Z",
};

export const dummyOrganizationUserRow = {
  userId: "string",
  userName: "string",
};

export const dummyCustomerRow = {
  customerId: 1,
  fullName: "string",
  shortName: "string",
  licenseExpirationDate: "2025-01-11T19:53:00.057Z",
  maximumTransactionCount: 0,
  active: true,
  createdBy: "string",
  lastUpdatedBy: "string",
  createdTime: "2025-01-11T19:53:00.057Z",
  lastUpdatedTime: "2025-01-11T19:53:00.057Z",
};

export const dummyCustomerOrganizationRow = {
  organizationId: 1,
  organizationName: "string",
};
